import Vue from 'vue';
import axios from 'axios';

const meta = document.head.querySelector('meta[name="temp-report-token"]');

export const tempReportToken = meta ? meta.content : null;

const isRestRequest = (url) => {
    if (typeof url !== 'string') {
        return false;
    }

    const target = new URL(url, window.location.origin);

    return target.origin === window.location.origin && target.pathname.startsWith('/rest/');
};

export const addTempReportParams = (config) => {
    if (tempReportToken && isRestRequest(config.url)) {
        config.params = { temp_report: 1, public_token: tempReportToken, ...(config.params || {}) };
    }

    return config;
};

if (tempReportToken) {
    axios.interceptors.request.use(addTempReportParams);
    Vue.prototype.$http.interceptors.request.use(addTempReportParams);
    Vue.prototype.$silentHttp.interceptors.request.use(addTempReportParams);
}
